export const EMPTY_ARRAY: ReadonlyArray<any> = []
